import { configureStore } from '@reduxjs/toolkit'
import userReducer from './userSlice'
import statsReducer from './statsSlice'

export const store = configureStore({
  reducer: {
    user: userReducer,
    stats: statsReducer,
  },
})

